<template>
    <div>
        <Nav bgColor="#39A5BF" />
        <div class="d-flex align-items-center justify-content-center pt-3" style="background-color: #39A5BF">

            <!-- <div class="d-flex align-items-center text-start text-white"> -->
             <div class="container-fluid px-0 pt-3">
                  <div class="col-12 col-lg-8 offset-lg-2">
                    <img :src="`${$API_ASSETS}40e7688f-e6c5-444b-8a2f-8db0c435eb63.png`" class="img-fluid w-100" />
                  </div>
             </div>
            <!-- </div> -->

        </div>
        <div class="container-fluid pt-2" style="background-color: #39A5BF">
            <div class="col-12 col-md-6 offset-md-3 text-white text-center">
                <div class="py-2">
                    Atlas Improv was founded in early 2004 by Mary Parmentier and Bryan Judkins. Their dream was to
                    explore and innovate beyond what was familiar.Our story goes back further than just a few years
                    though. In the mid 1980s, Dick Chudnow, founder of ComedySportz, brought his brand of competitive
                    improv comedy to Madison, and a figurative seed was figuratively planted.
                </div>
                <div class="py-2">
                    As ComedySportz - Madison, we performed mainly short-form, a type of improvisational theatre where a
                    show is segmented into five-to-ten-minute scenes and games. We loved what we were doing, and, during
                    that time, we developed one of the show formats that we still perform today. It's as engaging for
                    audiences and performers as ever. Each show is fresh and fun.
                </div>
                <div class="py-2">
                    As managers, Parmentier and Judkins sought a creative environment that challenged and fulfilled us
                    artistically. They knew that we were capable of more and wanted to push us to new heights. They
                    realized
                    short-form wasn't enough. In 2004, they started Atlas Improv. The active members of ComedySportz -
                    Madison followed Parmentier and Judkins to do something new and amazing.
                </div>
                <div class="py-2 pb-5">
                    Today, Atlas Improv fosters an expert in each of its players. In story arc, character building, or
                    pure wit, every performer is a master.</div>
            </div>
        </div>

        <div class="bg-dark w-100 mb-5" style="height: 2px;"></div>

        <MembersSection />
        <div class="container-fluid position-relative pt-2 site-black-bg"
            style="margin: 0; padding-left:0;padding-right: 0; width: 100%; height: auto; object-fit: fill;">
            <!-- Desktop Version (Visible on extra-large screens and up) -->
            <div class="d-none d-xl-block position-relative">
                <img :src="`${$API_ASSETS}98b0081e-eab9-4b4a-a161-a61f9e16af9f.png`" class="img-fluid w-100" />

                <!-- Overlayed Text -->
                <div class="position-absolute w-100" style="top: 30%; left: 0; padding-left: 10%;">
                    <div class="col-lg-4 text-white text-start">
                        <div class="text-uppercase display-4 oswald-bold">Auditions</div>
                        <div class="py-2">
                            Think you've got a natural talent for performance? Are you quick on your feet and like to
                            make things up as you go? If so, you're in luck: Atlas Improv is holding open call
                            auditions!
                        </div>
                        <div v-if="audition" class="py-2">
                            Auditions will be held {{ audition?.day_1 }} and {{ audition?.day_2 }} from {{ audition?.time_range }} each day.
                            You need only attend one of the two sessions, no need to bring a headshot or resume. All we
                            ask is that you come dressed to move and prepared to play (close-toed shoes please). No
                            experience required, all are welcome to apply.
                        </div>
                    </div>
                </div>
            </div>

            <!-- Mobile/Tablet Version (Visible up to 1024px wide) -->
            <div class="d-block d-xl-none text-white text-start">
                <div class="text-uppercase h2 px-3 text-center pt-4 py-2">Auditions</div>
                <div class="py-2 px-5">
                    Think you've got a natural talent for performance? Are you quick on your feet and like to
                    make things up as you go? If so, you're in luck: Atlas Improv is holding open call auditions!
                </div>
                <div v-if="audition" class="py-2 px-5">
                    Auditions will be held {{ audition?.day_1 }} and {{ audition?.day_2 }} from {{ audition?.time_range }} each day.
                    You need only attend one of the two sessions, no need to bring a headshot or resume. All we
                    ask is that you come dressed to move and prepared to play (close-toed shoes please). No
                    experience required, all are welcome to apply.
                </div>
                <img :src="`auditions-mobile.png`" class="img-fluid w-100"
                    style="margin: 0; padding-right: 0; width: 100%; height: auto; object-fit: fill;" />
            </div>
        </div>

        <Footer />

    </div>



</template>

<script>

import axios from 'axios';
import { DateTime } from 'luxon';
import Footer from '../components/Footer.vue'
import Nav from "../components/Nav.vue"
import MembersSection from '@/components/MembersSection.vue';


export default {
    name: 'Company',
    components: {
        Nav, Footer, MembersSection
    },
    data() {
      return {
        audition: null,
      };
    },
    methods: {
      async fetchAuditionDates() {
        try {
          const response = await axios.post(this.$API_GRAPHQL, {
            query: `
              query {
                audition {
                  day_1
                  day_2
                }
              }
            `
          }, {
            headers: {
              Authorization: `Bearer Pm4Nd5_e46HaK2xtkPcla2PMBzbk9AQf`,
              'Content-Type': 'application/json'
            }
          });
          const day1 = DateTime.fromISO(response.data.data.audition.day_1);
          const day2 = DateTime.fromISO(response.data.data.audition.day_2);

          this.audition = {
            day_1: day1.toFormat('cccc, LLLL d'),
            day_2: day2.toFormat('cccc, LLLL d'),
            time_range: `${day1.toFormat('h:mm a')}–${day1.plus({ hours: 2 }).toFormat('h:mm a')}`
          };
        } catch (error) {
          console.error('Error fetching audition dates:', error);
        }
      }
    },
    created() {
      this.fetchAuditionDates();
    },
};
</script>
